import { CSSProperties, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { ICoords } from "../../@types/GoogleMaps/ICoord";
import { DrawOnMap } from "../EditOnboarding/Components/DrawOnMap/DrawOnMap";
import { formatErrorMessageV2 } from "../FormControlsV2";

type DrawOnMapSlotV2Props = {
  value: ICoords;
  onChange: (coords: ICoords) => void;
  initialsLabel: string;
  staticsElements?: ICoords[];
  fitCoords?: ICoords;
  editable?: boolean;
  error?: string;
  style?: CSSProperties;
};

type DrawOnMapForm = {
  map_coords: ICoords;
};

export function DrawOnMapSlotV2({
  value,
  onChange,
  initialsLabel,
  staticsElements = [],
  fitCoords,
  editable = true,
  error,
  style,
}: DrawOnMapSlotV2Props) {
  const lastEmittedCoords = useRef("");
  const onChangeRef = useRef(onChange);
  const { control, watch, setValue } = useForm<DrawOnMapForm>({
    defaultValues: {
      map_coords: value || [],
    },
  });
  const mapCoords = watch("map_coords");

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  useEffect(() => {
    const current = JSON.stringify(mapCoords || []);
    const next = JSON.stringify(value || []);
    if (current !== next && next !== lastEmittedCoords.current) {
      setValue("map_coords", value || []);
    }
  }, [value, mapCoords, setValue]);

  useEffect(() => {
    if ((!mapCoords || mapCoords.length === 0) && value?.length > 0) return;

    const current = JSON.stringify(mapCoords || []);
    if (current === lastEmittedCoords.current) return;

    lastEmittedCoords.current = current;
    onChangeRef.current((mapCoords || []) as ICoords);
  }, [mapCoords, value?.length]);

  return (
    <div className={`ov2-draw-map-slot ${error ? "ov2-draw-map-slot--error" : ""}`}>
      <DrawOnMap
        staticsElements={staticsElements}
        initialsLabel={initialsLabel || "Mapa"}
        mainPolygon={(value || []) as ICoords}
        fitCoords={fitCoords}
        editable={editable}
        control={control}
        name="map_coords"
        style={style || { width: "100%", height: "240px" }}
      />
      {error && <small className="ov2-field__error animation__fadeIn">{formatErrorMessageV2(error)}</small>}
    </div>
  );
}
